<template>

  <!-- Page content -->
  <div class="page-content">

    <!-- Main navbar -->
    <div class="navbar navbar-expand-md navbar-dark bg-indigo-800 fixed-top">
      <div class="navbar-brand">
        <a href="/" class="d-inline-block">
          <img src="static/global_assets/images/logo_light.png" alt="XPOS">
        </a>
      </div>

      <div class="d-md-none">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
          <i class="icon-tree5"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
          <i class="icon-paragraph-justify3"></i>
        </button>
      </div>

      <div class="collapse navbar-collapse" id="navbar-mobile">

<!--        <ul class="navbar-nav">-->
<!--          <li class="nav-item">-->
<!--            <a href="#" class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">-->
<!--              <i class="icon-paragraph-justify3"></i>-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->

        <ul class="navbar-nav ml-auto" v-if="loggedin">
          <li class="nav-item">
          <a href="#" class="navbar-nav-link" >
            {{welcomemsg}}
          </a>
          </li>

          <li class="nav-item dropdown" >
            <a href="#" class="navbar-nav-link">
              <i class="icon-bell2"></i>
              <span class="d-md-none ml-2">Notifications</span>
              <span class="badge badge-mark border-white ml-auto ml-md-0"></span>
            </a>
          </li>

          <li class="nav-item dropdown dropdown-user" >
            <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
              <span>{{username}}</span>
            </a>


            <div class="dropdown-menu dropdown-menu-right">
              <router-link class="dropdown-item" to="/messages"><i class="icon-comment-discussion"></i>
                Messages <span class="badge badge-pill bg-blue ml-auto">1</span>
              </router-link>

              <a href="#" class="dropdown-item" id="usertoken">
                <i class="icon-touch"></i> <span >###</span>
              </a>

              <div class="dropdown-divider"></div>

              <router-link class="dropdown-item" to="/login"><i class="icon-switch2"></i> Logout
              </router-link>
            </div>
          </li>

        </ul>
      </div>
    </div>
    <!-- /main navbar -->

    <!-- Main sidebar -->
    <div class="sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md">

      <!-- Sidebar mobile toggler -->
      <div class="sidebar-mobile-toggler text-center">
        <a href="#" class="sidebar-mobile-main-toggle">
          <i class="icon-arrow-left8"></i>
        </a>
        Navigation
        <a href="#" class="sidebar-mobile-expand">
          <i class="icon-screen-full"></i>
          <i class="icon-screen-normal"></i>
        </a>
      </div>
      <!-- /sidebar mobile toggler -->

      <!-- Sidebar content -->
      <div class="sidebar-content">

        <!-- Main navigation -->
        <div class="card card-sidebar-mobile">
          <ul class="nav nav-sidebar" data-nav-type="accordion">

            <!-- Main -->
            <li class="nav-item">
              <a href="#" class="nav-link">
                <i class="icon-home4"></i>
                <span>Dashboard</span>
              </a>
            </li>
            <!-- /main -->

            <!-- POS -->
            <li class="nav-item-header">
              <div class="text-uppercase font-size-xs line-height-xs">POS</div>
              <i class="icon-menu" title="POS"></i>
            </li>
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-droplet"></i> <span>POS</span></a>

              <ul class="nav nav-group-sub" data-submenu-title="POS">
                <li class="nav-item"><router-link class="nav-link" to="/settlement">Settlement</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/bills">Bills</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/digitalbills">Digital Bills</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/priceupdate">Price Update</router-link></li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Receipts</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newpartyreceipt">New Party Receipt</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openpartyreceipt">Open Party Receipt List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Vault</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newvaultpayment">New Vault Payment</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openvaultpayment">Open Vault Payments</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/newvaultreceipt">New Vault Receipt</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openvaultreceipt">Open Vault Receipts</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Payment</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newhopayment">New HO Payment</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openhopayment">Open HO Payment List</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/newexpense">New Expense</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openexpense">Open Expense List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Digital Pay</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newdigitalpay">New Digital Pay</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opendigitalpay">Open Digital Pay List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Pump Entries</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newdipentry">New Dip Entry</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opendipentry">Open Dip Entry List</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/newmeterreading">New Meter Reading</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openmeterreading">Open Meter Reading List</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/newtesting">New Test Entry</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opentesting">Open Test Entry List</router-link></li>

                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Stock</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newtransfer">New Transfer</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opentransfer">Open Transfer List</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/newadjustment">New Adjustment</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openadjustment">Open Adjustment List</router-link></li>
                  </ul>
                </li>



              </ul>
            </li>
            <!--/POS -->

            <!-- Office -->
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-puzzle2"></i> <span>Accounts</span></a>
              <ul class="nav nav-group-sub" data-submenu-title="Accounts">

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Contra</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newcontra">New Contra</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opencontra">Open Contra List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Receipt</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newreceipt">New Receipt</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openreceipt">Open Receipt List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Payment</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newpayment">New Payment</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/openpayment">Open Payment List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                <a href="#" class="nav-link">Journal</a>
                <ul class="nav nav-group-sub">
                <li class="nav-item"><router-link class="nav-link" to="/newjournal">New Journal</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/openjournal">Open Journal List</router-link></li>
                </ul>
                </li>

                <li class="nav-item-divider"></li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Credit Note</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newcreditnote">New Credit Note</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opencreditnote">Open Credit Note List</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Debit Note</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/newdebitnote">New Debit Note</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/opendebitnote">Open Debit Note List</router-link></li>
                  </ul>
                </li>

              </ul>
            </li>
            <!--/Office -->

            <!-- Purchase -->
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-cart-add2"></i> <span>Purchase</span></a>

              <ul class="nav nav-group-sub" data-submenu-title="Purchase">

                <li class="nav-item"><router-link class="nav-link" to="/newfuelinvoice">New Fuel Invoice</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/openfuelinvoice">Open Fuel Invoice List</router-link></li>
                <li class="nav-item-divider"></li>
                <li class="nav-item"><router-link class="nav-link" to="/newinvoice">New Invoice</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/openinvoice">Open Invoice List</router-link></li>
                <li class="nav-item-divider"></li>
                <li class="nav-item"><router-link class="nav-link" to="/openinvoicepayment">Open Payment List</router-link></li>

              </ul>
            </li>
            <!--/Purchase -->

            <!--Sale-->
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-calculator"></i> <span>Sale</span></a>

              <ul class="nav nav-group-sub" data-submenu-title="Sale">
                <li class="nav-item"><router-link class="nav-link" to="/newsaleinvoice">New Sale Invoice</router-link></li>
                <li class="nav-item"><router-link class="nav-link" to="/opensaleinvoice">Open Sale Invoice List</router-link></li>
                <li class="nav-item-divider"></li>

                <li class="nav-item"><router-link class="nav-link" to="/opensalereceipt">Open Sale Receipt</router-link></li>

              </ul>
            </li>
            <!--/Sale-->

            <!-- reports -->
            <li class="nav-item-header">
              <div class="text-uppercase font-size-xs line-height-xs">Reports</div>
              <i class="icon-menu" title="Reports"></i></li>
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-stack"></i> <span>Reports</span></a>

              <ul class="nav nav-group-sub" data-submenu-title="Reports">
                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Accounts</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/daybook_display">Day Book</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/ledger_display">Ledger</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/group_summary_display">Group Summary</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/tds_summary_display">TDS Summary</router-link></li>
                    <li class="nav-item-divider"></li>
                    <li class="nav-item"><router-link class="nav-link" to="/trailbalance">Trial Balance</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/pandl">Profit & Loss</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/balancesheet">Balance Sheet</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">GST</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/gst3b">3B</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/gst3bdetailed">3B Detailed</router-link></li>
                  </ul>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/actualvsportal">Actual Vs Portal</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link">Sale</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/posbills">POS Bill</router-link></li>
                  </ul>
                </li>


              </ul>
            </li>
            <!--/reports -->

            <!-- Master -->
            <li class="nav-item-header">
              <div class="text-uppercase font-size-xs line-height-xs">Master</div>
              <i class="icon-menu" title="Master"></i>
            </li>
            <li class="nav-item nav-item-submenu">
              <a href="#" class="nav-link"><i class="icon-gear"></i> <span>Master</span></a>

              <ul class="nav nav-group-sub" data-submenu-title="Master">

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link"><i class="icon-puzzle"></i>Accounting</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/ledgergroup">Ledger Group</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/ledger">Ledger</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link"><i class="icon-profile"></i>Inventory</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/itemgroup">Group</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/item">Item</router-link></li>
                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link"><i class="icon-user-tie"></i>Vendors</a>
                  <ul class="nav nav-group-sub">
                    <li class="nav-item"><router-link class="nav-link" to="/supplier">Supplier</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/buyer">Customer</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/serviceprovider">Service Providers</router-link></li>
<!--                    <li class="nav-item-divider"></li>-->

                  </ul>
                </li>

                <li class="nav-item nav-item-submenu">
                  <a href="#" class="nav-link"><i class="icon-drive"></i>Fuel</a>
                  <ul class="nav nav-group-sub">


                    <li class="nav-item"><router-link class="nav-link" to="/dipchart"><i class="icon-list-numbered"></i>Dip Chart </router-link></li>
                    <li class="nav-item nav-item-submenu">
                      <a href="#" class="nav-link"><i class="icon-bus"></i>Vehicles</a>
                      <ul class="nav nav-group-sub">
                        <li class="nav-item"><router-link class="nav-link" to="/vehiclecategory">Cateogry</router-link></li>
                        <li class="nav-item"><router-link class="nav-link" to="/vehicle">Vehicle</router-link></li>
                      </ul>
                    </li>

                    <li class="nav-item nav-item-submenu">
                      <a href="#" class="nav-link"><i class="icon-bubble8"></i>Stock Location</a>
                      <ul class="nav nav-group-sub">
                        <li class="nav-item"><router-link class="nav-link" to="/outlet">Outlet</router-link></li>
                        <li class="nav-item"><router-link class="nav-link" to="/tank">Tank</router-link></li>
                        <li class="nav-item"><router-link class="nav-link" to="/bay">Bay</router-link></li>
                        <li class="nav-item"><router-link class="nav-link" to="/nozzle">Nozzle</router-link></li>
                      </ul>
                    </li>


                    <li class="nav-item"><router-link class="nav-link" to="/terminal"><i class="icon-calculator4"></i>Terminal</router-link></li>

                    <li class="nav-item"><router-link class="nav-link" to="/cashier"><i class="icon-users2"></i>Cashier</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/saleman"><i class="icon-users4"></i>Sales Man</router-link></li>
                  </ul>
                </li>

              </ul>
            </li>
            <!--/Master -->

            <!-- logout -->
            <li class="nav-item-header">
              <div class="text-uppercase font-size-xs line-height-xs">Logout</div>
              <i class="icon-menu" title="Logout"></i>
            </li>

            <router-link class="dropdown-item" to="/login"><i class="icon-switch2"></i> Logout </router-link>
            <!--/logout -->

          </ul>
        </div>
        <!-- /main navigation -->

      </div>
      <!-- /sidebar content -->

    </div>
    <!-- /main sidebar -->

    <!-- Main content -->
    <div class="content-wrapper">

      <!-- Page header -->
      <div v-if="pageheader_visible" class="page-header page-header-light">

        <div class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
          <div class="d-flex">
            <div class="breadcrumb">
              <a href="index.html" class="breadcrumb-item"><i class="icon-home2 mr-2"></i> Home</a>
              <a href="#" class="breadcrumb-item">Link</a>
              <span class="breadcrumb-item active">Current</span>
            </div>

            <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
          </div>

          <div class="header-elements d-none">
            <div class="breadcrumb justify-content-center">
              <a href="#" class="breadcrumb-elements-item">
                Link
              </a>

              <div class="breadcrumb-elements-item dropdown p-0">
                <a href="#" class="breadcrumb-elements-item dropdown-toggle" data-toggle="dropdown">
                  Dropdown
                </a>

                <div class="dropdown-menu dropdown-menu-right">
                  <a href="#" class="dropdown-item">Action</a>
                  <a href="#" class="dropdown-item">Another action</a>
                  <a href="#" class="dropdown-item">One more action</a>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item">Separate action</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page header -->

      <!-- Content area -->
      <div class="content" style="padding: 10px;">

        <router-view/>

      </div>
      <!-- /content area -->

      <!-- Footer -->
      <!--<div class="navbar navbar-expand-lg navbar-light fixed-bottom">-->
      <div  id="appfooter" class="navbar navbar-expand-lg navbar-light ">
        <div class="text-center d-lg-none w-100">
          <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
            <i class="icon-unfold mr-2"></i>
            Footer
          </button>
        </div>

        <div class="navbar-collapse collapse" id="navbar-footer">
            <span class="navbar-text">
                &copy; 2019. <a href="#">Limitless </a> by <a href="#" target="_blank">Py Labs</a>
            </span>
        </div>
      </div>
      <!-- /footer -->

      <!-- Validation form -->
      <div id="modal-validation" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-sm modal-dialog-centered">
          <div class="modal-content">

            <!-- Form -->
            <form class="modal-body form-validate" action="#">
              <div class="text-center mb-3">
                <i class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
                <h5 class="mb-0">Choose your Branch</h5>
                <span class="d-block text-muted">& Financial Year</span>
              </div>

              <div class="form-group form-group-feedback form-group-feedback-left">
                <select id="cmbbranch" class="form-control" required autofocus v-model="branch.code">
                  <option v-for="brn in branches" v-bind:value="brn.code">
                    {{ brn.name }}
                  </option>
                </select>
                <div class="form-control-feedback">
                  <i class="icon-box text-muted"></i>
                </div>
              </div>

              <div class="form-group form-group-feedback form-group-feedback-left">
                <select class="form-control" required v-model="financialyear">
                  <option value="2019">2019</option>
                </select>
                <div class="form-control-feedback">
                  <i class="icon-calendar2 text-muted"></i>
                </div>
              </div>

              <div class="form-group d-flex align-items-center">
                <div class="custom-control custom-checkbox mb-3">
                  <input type="checkbox" class="custom-control-input" id="cbremember" >
                  <label class="custom-control-label" for="cbremember">Remember</label>
                </div>

              </div>

              <div class="form-group">
                <button type="button" class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple btn-block" >Let's Go <i class="icon-circle-right2 ml-2"></i></button>
              </div>

            </form>
            <!-- /form -->

          </div>
        </div>
      </div>
      <!-- /validation form -->

    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->

</template>

<script>
import moment from 'moment-timezone'
import { userService } from '@/store/auth-header.js'
import { store } from '@/store/store.js'

export default {
  components: {

  },
  store,
  data () {
    return {
      branches: [],
      branch: { 'id': '', 'code': 1, 'type': 0, 'name': '', 'street': '', 'city': '', 'pincode': '', 'state_cd': 33, 'contact_person': '', 'telephone': '', 'email': '' },
      financialyear: 0,
      pageheader_visible: false,
      welcomemsg: 'Welcome, Admin!',
      loggedin: false,
      username: '',
      usertoken: '',
    }
  },
  watch: {
    'store.state': function (newVal) {
    }
  },
  created () {
    // $('#applist').hide();

    // this.$data.loggedin = userService.isloggedIn();
    // alert( JSON.stringify(this.$route.params));
    // alert(store.state.token);
  },
  mounted () {
    const self = this;


    if (userService.isloggedIn()) {
      this.$data.loggedin = true;

      let user = JSON.parse(localStorage.getItem('xposuser'));
      store.state.user = user;

      store.state.token = localStorage.getItem('xpostoken');

      this.$data.welcomemsg = store.state.user.branch.name + ' @ ' + store.state.user.finyear

      this.$data.username = user.name;

    } else {
      this.$data.loggedin = false
      this.$router.push({ path: '/login' })
    }

    $('#modal-validation').on('shown.bs.modal', function () {
      // console.log(JSON.stringify(self.$data.branches));
    })
  },
  methods: {

  }
}
</script>
